<template>
  <div id="intro-3" class="intro-box">
    <div class="intro-box__wrapper">
      <div class="intro-box__header">
        <h3>Calculation Type</h3>
      </div>

      <div class="intro-box__content">
        <p>Do you want to track commissions as a percentage of the sale or a flat rate per
          product?</p>

        <div class="intro-box__actions">
          <div class="form-field">
            <div class="grid-x grid-padding-x">
              <div class="cell auto text-right">
                <label :class="['radio-choice', chosen === false ? 'active' : '']"
                       @click="choose(false)">Percentage</label>
              </div>

              <div class="cell auto text-left">
                <label :class="['radio-choice', chosen ? 'active' : '']" @click="choose(true)">Flat
                  Rate</label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="intro-box__footer">
      <button :class="['button--wide', chosen === null ? 'disabled': '']" @click="changeStep">
        Next
      </button>

      <div style="padding: 10px 0;"><a href="https://calendly.com/support-visceral/onboarding" target="_blank">Need help with getting setup?</a></div>

      <!--      <div class="intro-box__skip">configure later</div>-->
    </div>

    <div class="intro-box__pagination">
      <span></span>
      <span></span>
      <span></span>
      <span class="active"></span>
      <span></span>
      <span></span>
      <span></span>
      <span></span>
    </div>
  </div>
</template>

<script>
import client from '@/mixins/client'

export default {
  mixins: [
    client
  ],
  data: function () {
    return {
      chosen: null
    }
  },
  methods: {
    choose (choice) {
      this.chosen = choice
    },
    changeStep (next = true) {
      if (this.chosen !== null) {
        this.request('put', '/settings/settings/' + this.$store.state.settings.id + '/retrieve-update/', {
          use_cost_per_item: this.chosen
        }).then(response => {
          if (this.chosen) {
            this.$emit('changeStep', next)
          } else {
            this.$emit('goToStep', 'step4A')
          }
        })
      }
    }
  }
}
</script>

<style lang="scss">
  @import '../../../styles/mixins';
  @import '../../../styles/variables';
</style>



// WEBPACK FOOTER //
// src/apps/vendorconsignment/tutorials/step4.vue